// Keyframe helpers for the /web-uploader animations (see AnimatedFigure.tsx).

export type Stop = readonly [pct: number, css: string];

export const r = (n: number) => Math.round(n * 100) / 100;

/** `@keyframes name { pct% { css } … }` — stops at the same % merge, last wins. */
export const kf = (name: string, stops: readonly Stop[]): string => {
  const byPct = new Map<number, string>();
  for (const [p, css] of stops) byPct.set(r(Math.max(0, Math.min(100, p))), css);
  return `@keyframes ${name}{${[...byPct.entries()]
    .sort((a, b) => a[0] - b[0])
    .map(([p, css]) => `${p}%{${css}}`)
    .join("")}}`;
};

export const tr = (x: number, y: number, s = 1) => `transform:translate(${r(x)}px,${r(y)}px)${s !== 1 ? ` scale(${r(s)})` : ""}`;

/** Smooth in-out for the segment that starts at this stop. */
export const EASE = "animation-timing-function:cubic-bezier(.45,0,.25,1)";
export const LINEAR = "animation-timing-function:linear";

